import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading2, ArticleHeading1, IconChevronRight16 } from '@cian/ui-kit';

import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';
import { IFAQCategory } from '../../types/promoInfo';
import { BigHeading } from '../BigHeading';
import { getPluralNoun } from '../../utils/getPluralNoun';

import * as styles from './styles.css';

interface IFAQSection extends IWithDeviceTypeProps {
  content: IFAQCategory[];
  onCategoryClick: (modalContent: IFAQCategory) => void;
}

/**
 * Секция "Часто задаваемые вопросы".
 */
const FAQSection: React.FC<React.PropsWithChildren<IFAQSection>> = ({
  isPhone,
  deviceType,
  onCategoryClick,
  content,
}) => {
  const Heading = isPhone ? ArticleHeading1 : BigHeading;

  return (
    <div>
      <Heading as="h2">Часто задаваемые вопросы</Heading>
      <div className={cn(styles['faq-categories'], styles[deviceType])}>
        {content.map((faqCategory, i) => {
          const categoryId = `faq-category-${i}`;
          const questionsCount = faqCategory.questions.length;

          return (
            <button
              key={i}
              type="button"
              onClick={() => onCategoryClick(faqCategory)}
              className={cn(styles['faq-category'], styles[deviceType])}
              aria-labelledby={categoryId}
            >
              <div>
                <span className={styles['questions-count']}>
                  {questionsCount} {getPluralNoun(questionsCount, 'вопрос', 'вопроса', 'вопросов')}
                </span>
                <ArticleHeading2 id={categoryId} as="h3" textAlign="left">
                  {faqCategory.category}
                </ArticleHeading2>
              </div>
              <span className={styles['arrow-icon']}>
                <IconChevronRight16 />
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

const FAQSectionWithDeviceType = withDeviceType(FAQSection);
export { FAQSectionWithDeviceType as FAQSection };
